<template>
    <div class="forgot">
        <div class="wrapper">
            <img
                class="logo"
                :src="require('@/assets/moodmix-logo.png')"
            />

            <form class="form" @submit.prevent="send()">
                <p>Please enter the email address you’ve used to register in upmood.</p>
                
                <div class="form-wrapper">
                    <span class="label">Email</span>
                    <input 
                        v-model="email" 
                        class="firstname" 
                        type="email" 
                        placeholder="Input email" 
                        required
                    >
                    <p class="error" v-if="error">{{ error }}</p>
                    
                    <vue-recaptcha
                        sitekey="6LedNLcZAAAAABJY9n3qDDrQPMTYyVoKwVbT4w1P"
                        :loadRecaptchaScript="true"
                        @verify="verify"
                    >
                    </vue-recaptcha>
                </div>

                <button class="login" type="submit" :disabled="loading">Send</button>
            </form>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import VueRecaptcha from "vue-recaptcha";
export default {
	data () {
		return {
			email: '',
			error: '',
			isRobot: true,
		}
	},
    
	computed: {
		...mapState({
			loading: state => state.loading,
		})
	},
    
	methods: {
		async send () {
			if (!this.isRobot) {
				this.error = await this.$store.dispatch('forgotPass', {email: this.email})
				if (!this.error) this.$router.push({name: 'SignIn'}) 
			} else {
				this.error = 'Please confirm you are not a robot.'
			}
		},
        
		verify () {
			this.isRobot = false
		}
	},
    
	components: {
		VueRecaptcha
	},
}
</script>

<style lang="scss" scoped>
.forgot {
    padding-top: 55px;

    .wrapper {
        display: flex;
        flex-direction: column;
        margin: auto;
        width: 400px;

        @include mobile {
            width: 300px;
        }

        .logo {
            width: 123px;
            height: 61px;
            margin: 0 auto 35px;
        }

        .form {
            display: flex;
            flex-direction: column;

            .form-wrapper {
                display: flex;
                flex-direction: column;
                margin-bottom: 50px;
                
                .error {
                    text-align: right;
                    color: #F4949A;
                }

                span {
                    color: #ffffff;
                    margin-bottom: 10px;
                }

                input {
                    padding: 5px;
                    border: 1px solid #BFCCE2;
                    border-radius: 3px;
                    opacity: 1;
                    margin-bottom: 5px;
                    height: 32px;

                    &::placeholder {
                        opacity: 1;
                        color: #BFCCE2;
                        font-size: 12px;
                    }
                }
            }

            p {
                font-size: 12px;
                color: #ffffff;
                margin-bottom: 15px;
            }

            button {
                width: 242px;
                margin: auto;
            }
        }
    }
}
</style>